<template>
  <div class="relative">
    <div v-if="loading" class="absolute left-0 top-44 w-full lg:top-72">
      <TheLoader />
    </div>
    <SummaryChart
      v-else
      :summary="detailedData"
      :table-summary="priceIndex.summary"
      :slug="slug"
      :title="indexTitle"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useGetData } from '~/composables/useGetData'
import type { TProduct } from '~/src/types/product'
import SummaryChart from '~/components/price-assessments/SummaryChart.vue'

const props = defineProps<{
  product: TProduct
}>()

const { priceIndex, getSummaryData } = useGetData(props.product.category)

const loading = ref(true)
const detailedData = ref({})
const slug = computed(() => props.product.reportSlug || props.product.slug)
const indexTitle = computed(() => `${props.product.name} Price Index`)

watch(priceIndex, () => {
  priceIndex.value?.detailed?.forEach((product) => {
    detailedData.value[product.product] = product.data
  })
})

onMounted(async () => {
  try {
    loading.value = true
    await getSummaryData()
  } catch (error) {
    logError(error)
  } finally {
    loading.value = false
  }
})
</script>
